import * as Yup from 'yup';

export const CONTACT_VALIDATION_SCHEMA = Yup.object().shape({
  mainText: Yup.string().required('Обязательное поле').max(500, 'Превышено допустимое количество символов'),
  additionalText: Yup.string()
    .required('Обязательное поле')
    .matches(
      /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/,
      'Введите корректный email',
    )
    .max(200, 'Превышено допустимое количество символов'),
});
